import React, { useEffect, useRef, useState } from 'react';
import OrgChart from '@balkangraph/orgchart.js';
import Form from "../components/form"
import { createNewMember, deleteMember, findDocumentByField, getFamilyMembers, getMember, updateMember, saveSetting } from '../library';
import { getDoc } from 'firebase/firestore';
import IconButton from '@mui/material/IconButton';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { getAuth, onAuthStateChanged, User, signOut } from 'firebase/auth';
import { auth } from '../firebaseData';
import { useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Stack, Tooltip, Typography, useMediaQuery, useTheme, TextField, InputBase, InputAdornment, FormControl, Select, MenuItem, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import StoryDetailDialog from '../components/storyDialog/detail';
import moment from "moment";
import AutohideSnackbar from '../components/alert';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import LanguageSelect from '../components/language/select';
import { translations } from '../translations';
import { useLanguage } from '../contexts/LanguageContext';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ParkRoundedIcon from '@mui/icons-material/ParkRounded';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import ts from 'typescript';

interface familyMember {
  id: string,
  name: string,
  img: string,
  note: string,
  pid: string,
  tags: string[],
  role: string,
  familyBranch?: string,
  gender: string,
  ppid?: string,
  position: string,
  created: Date,
  updated: Date
}

interface memberEntity {
  name: string,
  img: string,
  note: string,
  pid: string,
  tags: string[],
  role: string,
  birthday: {
    seconds: number,
    nanoseconds: number
  },
  deadthday: {
    seconds: number,
    nanoseconds: number
  },
  story: string,
  familyBranch?: string,
  ppid?: string,
  created: Date,
  updated: Date
}


interface formData {
  name: string,
  img: string,
  role: string,
  note: string,
  gender: string,
  birthday: {
    seconds: number,
    nanoseconds: number
  },
  deadthday: {
    seconds: number,
    nanoseconds: number
  },
  story: string,
  familyBranch?: string,
  id?: string,
  pid?: string,
  ppid?: string,
  tags?: string[],
  created?: Date,
  updated?: Date,
}

interface statusInterface {
  read: string,
  add: string,
  edit: string,
  delete: string,
}

type TranslationKey = keyof typeof translations.en;

const valueTranslations = {
  male: {
    en: 'Male',
    vi: 'Nam'
  },
  female: {
    en: 'Female',
    vi: 'Nữ'
  },
  sameGrade: {
    en: 'Same Grade',
    vi: 'Cùng thế hệ'
  },
  spouse: {
    en: 'Spouse',
    vi: 'Vợ/Chồng'
  },
  lowerGrade: {
    en: 'Lower Grade',
    vi: 'Thế hệ sau'
  }
};

const FamilyTree = () => {
  const chartRef = useRef(null);
  const [chart, setChart] = useState<any>(null);
  const [nodes, setNodes] = useState<familyMember[]>([])
  const nodesRef = useRef<familyMember[]>([]);
  useEffect(() => { nodesRef.current = nodes; }, [nodes]);
  const [treeTitle, setTreeTitle] = useState('')
  const [editTitleValue, setEditTitleValue] = useState('')
  const [openEditTreeTitle, setOpenEditTreeTitle] = useState(false)
  const [memberSelected, setMemberSelected] = useState<any | null>(null)
  const [openEditForm, setEditForm] = useState(false)
  const [formStatus, setFormStatus] = useState<string>('')
  const [openStory, setOpenStory] = useState(false)
  const [editorContent, setEditorContent] = useState('')
  const [activeNodeId, setActiveNodeId] = useState<string | null>(null);
  const [type, setType] = useState<'success' | 'error'>('success')
  const [snackbarContent, setSnackbarContent] = useState('')
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [userData, setUserData] = useState<any>(null);
  const [showSearch, setShowSearch] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState<string>('All');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { language, setLanguage } = useLanguage();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // ky hieu 
  // vo chong : pid : cua vo hoac chong cua phan tu dung truoc doi tuong chon , tags: [left-partner]
  //con : pid: cua cha hoac me cung duoc khong bat buoc phan tu dung truoc 

  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false)
  }

  const handleSetEditorContent = (value: string) => {
    if (editorContent !== value) {
      setEditorContent(value)
    }
  }

  const getMemberList = async () => {
    try {
      setIsLoading(true);
      let members = await getFamilyMembers('family_members')
      if (members && members.length > 0) {
        setNodes([...members]);
      }
    } catch (error) {
      console.error('Error fetching members:', error);
    } finally {
      setIsLoading(false);
    }
  }

  const getSettings = async () => {
    try {
      let settings = await getMember('settings', 'general');
      if (settings && settings.treeTitle) {
        setTreeTitle(settings.treeTitle);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  }

  useEffect(() => {
    getMemberList();
    getSettings();
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (loggedInUser) => {
      if (loggedInUser) {
        const userDocs = await findDocumentByField('users', 'email', loggedInUser.email);
        if (userDocs.length > 0) {
          setUserData(userDocs[0]);
        }
      } else {
        setUserData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleActionClick = (e: MouseEvent | TouchEvent) => {
      const target = e.target as HTMLElement | SVGElement;
      if (!target || !target.classList) return;

      const isAction = target.classList.contains('action-add') || target.classList.contains('action-edit') || target.classList.contains('action-read');

      if (isAction) {
        const nodeEl = target.closest('[data-n-id]') || target.closest('[node-id]');
        if (nodeEl) {
          const nodeId = nodeEl.getAttribute('data-n-id') || nodeEl.getAttribute('node-id');
          if (nodeId) {
            e.stopPropagation();
            e.preventDefault();

            let member = nodesRef.current.find((n: familyMember) => n.id === nodeId);
            if (target.classList.contains('action-add')) {
              setMemberSelected({ id: nodeId, ...member });
              hanleOpenEditForm();
              setFormStatus('add');
              setEditorContent('');
            } else if (target.classList.contains('action-edit')) {
              setMemberSelected({ id: nodeId, ...member });
              hanleOpenEditForm();
              setFormStatus('edit');
            } else if (target.classList.contains('action-read')) {
              setMemberSelected({ id: nodeId, ...member });
              handleCloseEditForm();
              setFormStatus('read');
              setOpenStory(true);
            }
          }
        }
      } else {
        // If they click outside any node, clear the active state
        const nodeEl = target.closest('[data-n-id]') || target.closest('[node-id]');
        if (!nodeEl) {
          setActiveNodeId(null);
        }
      }
    };

    document.addEventListener('click', handleActionClick, true);
    document.addEventListener('touchend', handleActionClick, true);
    return () => {
      document.removeEventListener('click', handleActionClick, true);
      document.removeEventListener('touchend', handleActionClick, true);
    };
  }, []);

  const translateNodeValue = (key: string, value: string) => {
    if (!value) return value;
    const translationKey = value.toLowerCase() as keyof typeof valueTranslations;
    return valueTranslations[translationKey]?.[language as 'en' | 'vi'] || value;
  };

  const translateNodeData = (node: familyMember) => {
    return {
      ...node,
      gender: node.gender === 'male' ? translations[language as keyof typeof translations].male :
        node.gender === 'female' ? translations[language as keyof typeof translations].female : node.gender,
      role: node.role === 'sameGrade' ? translations[language as keyof typeof translations].sameGrade :
        node.role === 'spouse' ? translations[language as keyof typeof translations].spouse :
          node.role === 'lowerGrade' ? translations[language as keyof typeof translations].lowerGrade : node.role,
      position: node.position === 'wife' ? translations[language as keyof typeof translations].wife :
        node.position === 'husband' ? translations[language as keyof typeof translations].husband :
          node.position === 'sister' ? translations[language as keyof typeof translations].sister :
            node.position === 'brother' ? translations[language as keyof typeof translations].brother :
              node.position === 'father' ? translations[language as keyof typeof translations].father :
                node.position === 'mother' ? translations[language as keyof typeof translations].mother :
                  node.position === 'son' ? translations[language as keyof typeof translations].son :
                    node.position === 'daughter' ? translations[language as keyof typeof translations].daughter :
                      node.position === 'grandson' ? translations[language as keyof typeof translations].grandson :
                        node.position === 'granddaughter' ? translations[language as keyof typeof translations].granddaughter :
                          node.position === 'uncle' ? translations[language as keyof typeof translations].uncle :
                            node.position === 'aunt' ? translations[language as keyof typeof translations].aunt :
                              node.position,
    };
  };

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isMobile && nodes.length > 0 && isFirstRender.current && chart) {
      const rootNodeId = nodes[0].id;
      setTimeout(() => {
        chart.center(rootNodeId, {
          vertical: true,
          horizontal: true,
        });
        isFirstRender.current = false;
      }, 100);
    }
  }, [nodes.length, chart]);


  useEffect(() => {
    if (chartRef.current && nodes.length > 0 && !isLoading) {
      let translatedNodes = nodes.map(translateNodeData);

      // Retroactively fix existing children to attach to both spouses
      translatedNodes = translatedNodes.map(node => {
        if (node.pid && !node.ppid && (!node.tags || (!node.tags.includes('right-partner') && !node.tags.includes('left-partner')))) {
          // Find spouse of this node's pid
          const spouse = translatedNodes.find(n => n.pid === node.pid && n.tags && n.tags.includes('right-partner'));
          if (spouse) {
            return { ...node, ppid: spouse.id };
          } else {
            const selfNode = translatedNodes.find(n => n.id === node.pid);
            if (selfNode && selfNode.tags && selfNode.tags.includes('right-partner') && selfNode.pid) {
              return { ...node, ppid: selfNode.pid };
            }
          }
        }
        return node;
      });

      const isAdmin = userData && userData.role === 'admin';
      OrgChart.templates.diva = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.diva.size = [200, 300];
      OrgChart.templates.diva.node =
        '<rect x="0" y="120" height="150" width="200" fill="#ffffff" stroke="var(--accent-color)" stroke-width="2" rx="16" ry="16" filter="drop-shadow(0 4px 12px rgba(74, 107, 44, 0.15))"></rect>'
        + '<circle cx="100" cy="90" fill="#ffffff" r="50" stroke="var(--accent-color)" stroke-width="3"></circle>'
        + '<g class="node-actions" style="opacity: 0; pointer-events: none; transition: opacity 0.2s;">'
        + (isAdmin ?
          '<circle class="action-add" cx="170" cy="110" r="18" fill="#6b8e51" cursor="pointer" />'
          + '<text class="action-add" fill="#ffffff" x="170" y="116" font-size="20" text-anchor="middle" cursor="pointer">+</text>'
          + '<circle class="action-edit" cx="30" cy="110" r="18" fill="#c96a52" cursor="pointer" />'
          + '<text class="action-edit" fill="#ffffff" x="30" y="115" font-size="16" text-anchor="middle" cursor="pointer">✎</text>'
          : '')
        + '</g>';
      OrgChart.templates.diva.img =
        '<clipPath id="{randId}"><circle cx="100" cy="90" r="45"></circle></clipPath>'
        + '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="50" y="40" width="100" height="100"></image>';
      // @ts-ignore
      OrgChart.templates.diva.familyBranch =
        `<text data-width="185" style="font-size: 14px; font-family: Inter; font-weight: 700;" fill="#c96a52" x="100" y="25" text-anchor="middle">{val}</text>`;
      // @ts-ignore
      OrgChart.templates.diva.name =
        '<text data-width="185" style="font-size: 18px; font-weight: 600; font-family: Inter;" fill="var(--text-primary)" x="100" y="165" text-anchor="middle">{val}</text>';
      // @ts-ignore
      OrgChart.templates.diva.gender =
        `<text data-width="185" style="font-size: 13px; font-family: Inter;" fill="var(--text-secondary)" x="100" y="185" text-anchor="middle">${translations[language as keyof typeof translations].gender}: {val}</text>`;
      // @ts-ignore
      OrgChart.templates.diva.formatBirthday =
        `<text data-width="185" style="font-size: 13px; font-family: Inter;" fill="var(--text-secondary)" x="100" y="205" text-anchor="middle">${translations[language as keyof typeof translations].birthday}: {val}</text>`;
      // @ts-ignore
      OrgChart.templates.diva.formatDeadthday =
        `<text data-width="185" style="font-size: 13px; font-family: Inter;" fill="var(--text-secondary)" x="100" y="223" text-anchor="middle">${translations[language as keyof typeof translations].deathday}: {val}</text>`;
      // @ts-ignore
      OrgChart.templates.diva.position =
        `<text data-width="185" style="font-size: 13px; font-weight: 500; font-family: Inter;" fill="var(--accent-hover)" x="100" y="242" text-anchor="middle">${translations[language as keyof typeof translations].position}: {val}</text>`;

      const newChart: any = new OrgChart(chartRef.current, {
        template: 'diva',
        siblingSeparation: 50,
        levelSeparation: 60,
        enableSearch: true,
        searchFields: ["name", "gender", "position", "formatBirthday", "formatDeadthday"],
        searchFieldsWeight: {
          "name": 100,
          "gender": 20,
          "position": 50,
          "formatBirthday": 10,
          "formatDeadthday": 10
        },
        nodeMouseClick: OrgChart.action.pan,
        nodeBinding: {
          name: 'name',
          gender: 'gender',
          formatBirthday: 'formatBirthday',
          formatDeadthday: 'formatDeadthday',
          position: 'position',
          img: 'img',
          familyBranch: 'familyBranch'
        },
        mouseScrool: OrgChart.action.zoom,
        enablePan: true,
        enableTouch: isMobile ? true : false,
        nodes: translatedNodes,
        scaleInitial: isMobile ? 0.4 : 0.8,
      });

      newChart.on('searchclick', function (sender: any, nodeId: string) {
        const node = sender.get(nodeId);
        if (node) {
          sender.center(nodeId, {
            vertical: true,
            horizontal: true
          });
          setShowSearch(false)
        } else {
          sender.setZoom(sender.getZoom());
          return;
        }
      });

      // Add keyboard event for search
      document.addEventListener('keydown', function (e: KeyboardEvent) {
        if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
          e.preventDefault();
          const searchBox = document.querySelector('.boc-search-input') as HTMLInputElement;
          if (searchBox) {
            searchBox.focus();
          }
        }
      });

      // Add CSS for search box
      const style = document.createElement('style');
      style.textContent = `
      .boc-link.boc-link-boc-button {
        width: 30px !important; 
        height: 30px !important;
        font-size: 13px !important; 
        padding: 0 !important; 
        margin: 10px 0px !important; 
        border-radius: 50% !important; 
        background-color: transparent !important;
        color: #808080 !important; 
        border: none !important; 
        cursor: pointer !important;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease-in-out; 
        box-shadow: none !important;
    }
    .boc-link.boc-link-boc-button:hover {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) !important;
        color: #000000 !important; 
        transform: scale(1.1); 
    }
    .boc-link.boc-link-boc-button:active {
        transform: scale(0.95); 
    }
     
    `;
      document.head.appendChild(style);

      let touchStartX: number;
      let touchStartY: number;
      let touchStartTime: number;
      let isDragging = false;
      let currentViewBox: any = null;

      newChart.element.addEventListener('touchstart', (e: TouchEvent) => {
        const touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = new Date().getTime();
        isDragging = false;
        currentViewBox = newChart.getViewBox();
      }, { passive: true });

      newChart.element.addEventListener('touchmove', (e: TouchEvent) => {
        if (!currentViewBox) return;

        const touch = e.touches[0];
        const moveX = touch.clientX - touchStartX;
        const moveY = touch.clientY - touchStartY;

        if (Math.abs(moveX) > 5 || Math.abs(moveY) > 5) {
          isDragging = true;
          const scale = newChart.getScale();
          // Update viewBox for panning effect
          newChart.setViewBox([
            currentViewBox[0] - moveX / scale,
            currentViewBox[1] - moveY / scale,
            currentViewBox[2],
            currentViewBox[3]
          ]);
        }

        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      newChart.element.addEventListener('touchend', async (e: TouchEvent) => {
        const touchEndTime = new Date().getTime();
        const touchDuration = touchEndTime - touchStartTime;

        if (!isDragging && touchDuration < 200) {
          const touch = e.changedTouches[0];
          const element = document.elementFromPoint(touch.clientX, touch.clientY);
          const nodeElement = element?.closest('[node-id]');

          if (nodeElement) {
            const nodeId = nodeElement.getAttribute('node-id');
            if (nodeId) {
              setActiveNodeId(nodeId);
            }
          }
        }
        isDragging = false;
        currentViewBox = null;
      }, { passive: true });

      setChart(newChart);

      // click node
      newChart.on('click', function (sender: any, args: any) {
        let nodeId = args.node.id;
        setActiveNodeId(prev => prev === nodeId ? null : nodeId);
      });

      newChart.on('redraw', function () {
        const spouseNodes = translatedNodes.filter((n: any) =>
          n.tags && (n.tags.includes('left-partner') || n.tags.includes('right-partner')) &&
          (n.role === translations[language as keyof typeof translations].spouse ||
            n.position === translations[language as keyof typeof translations].wife ||
            n.position === translations[language as keyof typeof translations].husband)
        );

        spouseNodes.forEach((spouse: any) => {
          const nodeEl = document.querySelector(`[node-id="${spouse.id}"], [data-n-id="${spouse.id}"]`);
          if (nodeEl && !nodeEl.querySelector('.heart-link')) {
            const isLeft = spouse.tags && spouse.tags.includes('left-partner');
            // The node width is 200, siblingSeparation is 50. Middle is 225 or -25.
            const cx = isLeft ? 225 : -25;

            nodeEl.insertAdjacentHTML('beforeend',
              `<g class="heart-link">
                <text x="${cx}" y="126" font-size="24" fill="#c96a52" text-anchor="middle" stroke="#fbf7f0" stroke-width="6" stroke-linejoin="round">❤</text>
                <text x="${cx}" y="126" font-size="24" fill="#c96a52" text-anchor="middle">❤</text>
               </g>`
            );
          }
        });
      });

    }

  }, [nodes.length, isLoading, userData, formStatus, language, isMobile]);

  useEffect(() => {
    const searchStyle = document.createElement('style');
    searchStyle.id = 'search-box-style';
    searchStyle.textContent = `
     .boc-search {
        top: ${isMobile ? '50px !important' : '0px !important'};
        right: 0px;
        position: absolute;
        padding: 0px !important;
        display: ${showSearch ? 'block' : 'none'} !important;
      }
      .boc-search-input {
        width: ${isMobile ? '200px' : '300px'} !important;
      }

      .boc-light{
        top: ${isMobile ? '-50px !important' : '0'}
      }
    `;

    // Remove existing search style if it exists
    const existingStyle = document.getElementById('search-box-style');
    if (existingStyle) {
      existingStyle.remove();
    }
    document.head.appendChild(searchStyle);

    return () => {
      searchStyle.remove();
    };
  }, [showSearch, isMobile]);

  //Translate placeholder of search box
  useEffect(() => {
    const updatePlaceholder = () => {
      const searchLabel = document.querySelector('.boc-input label') as HTMLLabelElement;
      if (searchLabel) {
        searchLabel.textContent = translations[language as keyof typeof translations].search || 'Search...';
      }
    };
    setTimeout(updatePlaceholder, 100);
    updatePlaceholder();
  }, [language]);

  const hanleOpenEditForm = () => {
    setEditForm(true)
  }

  const handleCloseEditForm = () => {
    setEditForm(false);
    setEditorContent('')
    setActiveNodeId(null);
  }

  const handleCloseStory = () => {
    setOpenStory(false);
    setActiveNodeId(null);
  }

  const getFormatDate = (data: any) => {
    let value = ''
    if (data.seconds) {
      value = moment.unix(data.seconds).format("DD/MM/YYYY");
    } else {
      value = moment(data).format("DD/MM/YYYY");
    }
    return value
  }

  const handleAddNewMember = async (formData: any) => {
    let formatNodes = [...nodes]
    delete formData["id"]
    let data: memberEntity = {
      ...formData,
      pid: '',
      tags: [],
      story: '',
      created: new Date(),
      updated: new Date()
    }
    if (memberSelected) {
      if (formData.role === 'sameGrade') {
        data.tags = ['left-partner']
      }
      else if (formData.role === 'spouse') {
        data.pid = memberSelected.id;
        data.tags = ['right-partner']
      } else if (formData.role === 'lowerGrade') {
        data.pid = memberSelected.id;

        // Find spouse to set ppid
        const spouse = formatNodes.find(n => n.pid === memberSelected.id && n.tags && n.tags.includes('right-partner'));
        if (spouse) {
          data.ppid = spouse.id;
        } else {
          const selfNode = formatNodes.find(n => n.id === memberSelected.id);
          if (selfNode && selfNode.tags && selfNode.tags.includes('right-partner') && selfNode.pid) {
            data.ppid = selfNode.pid;
          }
        }
      }
    }
    if (editorContent) {
      data.story = editorContent
    }
    let documentRef: any = await createNewMember('family_members', data)
    if (documentRef) {
      const docSnapshot = await getDoc(documentRef);
      if (docSnapshot.exists()) {
        const entity: any = docSnapshot.data();
        let dataExisted = formatNodes.find((e) => e.id === documentRef.id);
        if (!dataExisted) {
          entity.id = documentRef.id
          if (entity.birthday) {
            let formatBirthday = getFormatDate(entity.birthday)
            entity.formatBirthday = formatBirthday
          } else {
            entity.formatBirthday = ''
          }
          if (entity.deadthday) {
            let formatDeadthday = getFormatDate(entity.deadthday)
            entity.formatDeadthday = formatDeadthday
          } else {
            entity.formatDeadthday = ''
          }
          formatNodes.push(entity)
        }
        setNodes([...formatNodes])
        setType('success')
        setSnackbarContent('save data successfully')
        setOpenSnackbar(true)
      } else {
        setType('error')
        setSnackbarContent('Document does not created successfully')
        setOpenSnackbar(true)
        console.log('Document does not created successfully');
      }
    }
    handleCloseEditForm()
    setFormStatus('')
  }

  const handleSetFormStatus = (status: string) => {
    setFormStatus(status)
  }

  const handleEditNewMember = async (formData: any) => {
    let formatNodes = nodes.filter((e) => e.id.length === 20)

    if (formatNodes.length === 0 && formData.id) {
      delete formData["id"]
      if (editorContent) {
        formData.story = editorContent
      }

      let documentRef: any = await createNewMember('family_members', formData)
      if (documentRef) {
        const docSnapshot = await getDoc(documentRef);
        if (docSnapshot.exists()) {
          const entity: any = docSnapshot.data();
          let dataExisted = formatNodes.find((e: any) => e.id === documentRef.id);
          if (!dataExisted) {
            entity.id = documentRef.id
            if (entity.birthday) {
              let formatBirthday = getFormatDate(entity.birthday)
              entity.formatBirthday = formatBirthday
            } else {
              entity.formatBirthday = ''
            }
            if (entity.deadthday) {
              let formatDeadthday = getFormatDate(entity.deadthday)
              entity.formatDeadthday = formatDeadthday
            } else {
              entity.formatDeadthday = ''
            }
            formatNodes.push(entity)
          }
          setNodes([...formatNodes])
        } else {
          console.log('Document does not created successfully');
        }
      }
    } else {
      if (memberSelected && formData.id) {
        let entity = { ...formData }
        entity.story = editorContent
        delete entity['id']
        await updateMember('family_members', formData.id, entity);
        let formatFamilyMembers: any[] = formatNodes.map((e: any) => {
          if (formData.id && e.id === formData.id) {
            formData.role = formData.role ? formData.role : ''
            if (formData.birthday) {
              let formatBirthday = getFormatDate(formData.birthday)
              formData.formatBirthday = formatBirthday
            } else {
              formData.formatBirthday = ''
            }
            if (formData.deadthday) {
              let formatDeadthday = getFormatDate(formData.deadthday)
              formData.formatDeadthday = formatDeadthday
            } else {
              formData.formatDeadthday = ''
            }
            return formData
          } else {
            if (e.birthday) {
              let formatBirthday = getFormatDate(e.birthday)
              e.formatBirthday = formatBirthday
            } else {
              e.formatBirthday = ''
            }
            if (e.deadthday) {
              let formatDeadthday = getFormatDate(e.deadthday)
              e.formatDeadthday = formatDeadthday
            } else {
              e.formatDeadthday = ''
            }
            return e
          }
        })
        setNodes([...formatFamilyMembers])
        setType('success')
        setSnackbarContent('save data successfully')
        setOpenSnackbar(true)
      } else {
        setType('error')
        setSnackbarContent('data not found')
        setOpenSnackbar(true)
      }
    }
    handleCloseEditForm()
    setFormStatus('')
  }

  const handleDeleteMember = async (collectionName: string, memberId: string) => {
    let formatMembers = nodes.filter((e) => e.id !== memberId)
    setNodes([...formatMembers])
    await deleteMember(collectionName, memberId)
  }

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/')
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const handleZoomIn = () => {
    if (chart) {
      chart.zoom(1.2);
    }
  };

  const handleZoomOut = () => {
    if (chart) {
      chart.zoom(0.8);
    }
  };

  const handleLanguageChange = (newLanguage: string) => {
    setLanguage(newLanguage);
  }

  const uniqueBranches = Array.from(new Set(nodes.map(n => n.familyBranch).filter(b => b && b.trim() !== '')));

  const desktopMenuActions = (
    <>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={selectedBranch}
          onChange={(e: any) => setSelectedBranch(e.target.value)}
          displayEmpty
          sx={{
            height: '36px',
            borderRadius: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            backdropFilter: 'blur(12px)',
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '0.9rem',
            color: 'var(--text-primary)',
            '& fieldset': { borderColor: 'var(--glass-border)' },
            '&:hover fieldset': { borderColor: 'rgba(74, 107, 44, 0.4)' },
            '&.Mui-focused fieldset': { borderColor: 'var(--accent-color)' },
          }}
        >
          <MenuItem value="All">
            <em>{language === 'vi' ? 'Tất cả nhánh' : 'All Branches'}</em>
          </MenuItem>
          {uniqueBranches.map(branch => (
            <MenuItem key={branch} value={branch as string}>{branch as string}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <LanguageSelect value={language} onChange={handleLanguageChange} />
      <Tooltip title={translations[language as keyof typeof translations].search}>
        <IconButton sx={{ color: 'var(--text-primary)', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)', color: 'var(--accent-color)' } }} onClick={() => setShowSearch(!showSearch)}>
          <SearchRoundedIcon />
        </IconButton>
      </Tooltip>
      {
        userData && userData.role === 'admin' && <Tooltip title={translations[language as keyof typeof translations].users}>
          <IconButton sx={{ color: 'var(--text-primary)', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)', color: 'var(--accent-color)' } }} onClick={() => navigate('/users')}>
            <PeopleAltRoundedIcon />
          </IconButton>
        </Tooltip>
      }
      <Tooltip title={translations[language as keyof typeof translations].logout}>
        <IconButton sx={{ color: 'var(--text-primary)', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)', color: 'var(--accent-color)' } }} onClick={handleLogout}>
          <LogoutRoundedIcon />
        </IconButton>
      </Tooltip>
    </>
  );

  const mobileMenuContent = (
    <Box sx={{ width: 280, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, borderBottom: '1px solid var(--glass-border)' }}>
        <Typography variant="h6" sx={{ fontFamily: 'Inter', fontWeight: 600, color: 'var(--text-primary)' }}>
          {language === 'vi' ? 'Trình đơn' : 'Menu'}
        </Typography>
        <IconButton onClick={() => setMobileMenuOpen(false)} sx={{ color: 'var(--text-secondary)' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 3, flex: 1 }}>
        <Box>
          <Typography variant="caption" sx={{ mb: 1, display: 'block', color: 'var(--text-secondary)' }}>
            {language === 'vi' ? 'Nhánh gia đình' : 'Family Branch'}
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              value={selectedBranch}
              onChange={(e: any) => { setSelectedBranch(e.target.value); setMobileMenuOpen(false); }}
              displayEmpty
              sx={{
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                fontFamily: 'Inter',
                fontWeight: 600,
                color: 'var(--text-primary)',
              }}
            >
              <MenuItem value="All">
                <em>{language === 'vi' ? 'Tất cả nhánh' : 'All Branches'}</em>
              </MenuItem>
              {uniqueBranches.map(branch => (
                <MenuItem key={branch} value={branch as string}>{branch as string}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ mb: 1, display: 'block', color: 'var(--text-secondary)' }}>
            {language === 'vi' ? 'Ngôn ngữ' : 'Language'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
             <Button variant={language === 'vi' ? 'contained' : 'outlined'} onClick={() => { handleLanguageChange('vi'); setMobileMenuOpen(false); }} sx={{ flex: 1, borderRadius: '8px', color: language === 'vi' ? '#fff' : 'var(--text-primary)', backgroundColor: language === 'vi' ? 'var(--accent-color)' : 'transparent', borderColor: 'var(--glass-border)', '&:hover': { backgroundColor: language === 'vi' ? 'var(--accent-color)' : 'rgba(0,0,0,0.05)' } }}>Tiếng Việt</Button>
             <Button variant={language === 'en' ? 'contained' : 'outlined'} onClick={() => { handleLanguageChange('en'); setMobileMenuOpen(false); }} sx={{ flex: 1, borderRadius: '8px', color: language === 'en' ? '#fff' : 'var(--text-primary)', backgroundColor: language === 'en' ? 'var(--accent-color)' : 'transparent', borderColor: 'var(--glass-border)', '&:hover': { backgroundColor: language === 'en' ? 'var(--accent-color)' : 'rgba(0,0,0,0.05)' } }}>English</Button>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
          <Button 
            variant="outlined" 
            onClick={() => { setShowSearch(!showSearch); setMobileMenuOpen(false); }}
            sx={{ justifyContent: 'flex-start', color: 'var(--text-primary)', borderColor: 'var(--glass-border)', borderRadius: '8px', py: 1 }}
          >
            {translations[language as keyof typeof translations].search}
          </Button>

          {userData && userData.role === 'admin' && (
            <Button 
              variant="outlined" 
              startIcon={<PeopleAltRoundedIcon />} 
              onClick={() => { navigate('/users'); setMobileMenuOpen(false); }}
              sx={{ justifyContent: 'flex-start', color: 'var(--text-primary)', borderColor: 'var(--glass-border)', borderRadius: '8px', py: 1 }}
            >
              {translations[language as keyof typeof translations].users}
            </Button>
          )}

          <Button 
            variant="outlined" 
            color="error"
            startIcon={<LogoutRoundedIcon />} 
            onClick={handleLogout}
            sx={{ justifyContent: 'flex-start', borderRadius: '8px', py: 1, mt: 1 }}
          >
            {translations[language as keyof typeof translations].logout}
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return <Box sx={{ position: 'relative' }}>
    <Form language={language} nodes={nodes} handleSetEditorContent={handleSetEditorContent} editorContent={editorContent} openEditForm={openEditForm} handleAddNewMember={handleAddNewMember} handleEditNewMember={handleEditNewMember} hanleOpenEditForm={hanleOpenEditForm} handleCloseEditForm={handleCloseEditForm} formStatus={formStatus} memberSelected={memberSelected} />
    <Stack direction={'row'} alignItems={'center'} justifyContent={'center'}
      sx={{
        width: '100%',
        padding: isMobile ? '12px 16px' : '12px 24px',
        background: 'var(--glass-bg)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid var(--glass-border)',
        position: 'relative',
        zIndex: 10,
        boxSizing: 'border-box',
        boxShadow: '0 2px 10px rgba(74, 107, 44, 0.05)'
      }}
    >
      {
        !openEditTreeTitle && (
          <Box sx={{ order: isMobile ? 1 : 1, position: 'relative', display: 'flex', alignItems: 'center' }}>
            <Typography variant='h5' sx={{ textAlign: 'center', color: 'var(--text-primary)', fontWeight: 700, fontFamily: 'Inter', letterSpacing: '-0.5px', textShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              {treeTitle ? `${treeTitle}` : translations[language as keyof typeof translations].familyTree}
            </Typography>
            {userData && userData.role === 'admin' && (
              <IconButton
                sx={{
                  position: 'absolute',
                  left: '100%',
                  ml: 1,
                  color: 'var(--text-secondary)',
                  opacity: 0.6,
                  transition: 'all 0.2s ease',
                  '&:hover': { opacity: 1, color: 'var(--accent-color)', transform: 'scale(1.1)' }
                }}
                onClick={() => {
                  setEditTitleValue(treeTitle);
                  setOpenEditTreeTitle(true);
                }}
                size="small"
              >
                <DriveFileRenameOutlineIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        )
      }
      {
        openEditTreeTitle && (
          <Box sx={{ order: isMobile ? 1 : 1, display: 'flex', alignItems: 'center' }}>
            <TextField
              variant="outlined"
              size="small"
              autoFocus
              value={editTitleValue}
              onChange={(e) => setEditTitleValue(e.target.value)}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  if (editTitleValue !== treeTitle) {
                    await saveSetting('general', { treeTitle: editTitleValue });
                    setTreeTitle(editTitleValue);
                  }
                  setOpenEditTreeTitle(false);
                }
                if (e.key === 'Escape') {
                  setEditTitleValue(treeTitle);
                  setOpenEditTreeTitle(false);
                }
              }}
              placeholder={translations[language as keyof typeof translations].familyTree}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={async () => {
                      await saveSetting('general', { treeTitle: editTitleValue });
                      setTreeTitle(editTitleValue);
                      setOpenEditTreeTitle(false);
                    }} size="small" sx={{ color: 'var(--accent-color)' }}>
                      <CheckIcon fontSize="small" />
                    </IconButton>
                    <IconButton onClick={() => setOpenEditTreeTitle(false)} size="small" sx={{ color: 'error.main' }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              sx={{
                width: isMobile ? '240px' : '340px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: 'rgba(255, 255, 255, 0.4)',
                  backdropFilter: 'blur(12px)',
                  paddingRight: '4px',
                  '& fieldset': {
                    borderColor: 'var(--glass-border)',
                    borderWidth: '1px',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(74, 107, 44, 0.4)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'var(--accent-color)',
                    boxShadow: '0 4px 12px rgba(74, 107, 44, 0.1)',
                  }
                },
                input: {
                  color: 'var(--text-primary)',
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  textAlign: 'center'
                }
              }}
            />
          </Box>
        )
      }
      {!isMobile ? (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px',
            position: 'absolute',
            right: '24px',
            top: '50%',
            transform: 'translateY(-50%)' 
          }}>
          {desktopMenuActions}
        </Box>
      ) : (
        <IconButton onClick={() => setMobileMenuOpen(true)} sx={{ color: 'var(--text-primary)', position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)' }}>
          <MenuIcon />
        </IconButton>
      )}
    </Stack>
    
    <Drawer anchor="right" open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
      {mobileMenuContent}
    </Drawer>
    {
      formStatus === 'read' && openStory && <StoryDetailDialog
        hanleOpenEditForm={hanleOpenEditForm}
        handleSetFormStatus={handleSetFormStatus}
        avatar={memberSelected && memberSelected.img ? memberSelected.img : null}
        name={memberSelected && memberSelected.name ? memberSelected.name : ''}
        storyContent={memberSelected && memberSelected.story ? memberSelected.story : ''}
        role={userData && userData.role ? userData.role : ''}
        open={openStory}
        handleClose={handleCloseStory}
      />
    }
    <Stack direction="column" spacing={2} sx={{ position: 'fixed', bottom: '30px', right: '30px', zIndex: 1000 }}>
      <IconButton onClick={handleZoomIn} sx={{ backgroundColor: '#ffffff', border: '1px solid var(--glass-border)', boxShadow: '0 4px 14px rgba(74, 107, 44, 0.15)', color: 'var(--text-primary)', transition: 'all 0.2s', '&:hover': { backgroundColor: 'var(--accent-color)', color: '#ffffff', transform: 'translateY(-2px)' } }}>
        <ZoomInIcon />
      </IconButton>
      <IconButton onClick={handleZoomOut} sx={{ backgroundColor: '#ffffff', border: '1px solid var(--glass-border)', boxShadow: '0 4px 14px rgba(74, 107, 44, 0.15)', color: 'var(--text-primary)', transition: 'all 0.2s', marginTop: '12px !important', '&:hover': { backgroundColor: 'var(--accent-color)', color: '#ffffff', transform: 'translateY(-2px)' } }}>
        <ZoomOutIcon />
      </IconButton>
    </Stack>
    {isLoading ? (
      <Box
        sx={{
          position: 'fixed',
          top: isMobile ? '73px' : '63px',
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255,255,255,0.8)',
          zIndex: 1100
        }}
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress color="success" />
        </Stack>
      </Box>
    ) : null}

    {activeNodeId && (
      <style>
        {`
          [node-id="${activeNodeId}"] rect,
          [data-n-id="${activeNodeId}"] rect,
          [id="${activeNodeId}"] rect,
          g.node[data-n-id="${activeNodeId}"] rect {
              fill: rgba(201, 106, 82, 0.1) !important;
              stroke: #c96a52 !important;
              stroke-width: 4px !important;
          }
          
          [node-id="${activeNodeId}"] circle,
          [data-n-id="${activeNodeId}"] circle,
          [id="${activeNodeId}"] circle,
          g.node[data-n-id="${activeNodeId}"] circle {
              stroke: #c96a52 !important;
              stroke-width: 4px !important;
          }
          
          [node-id="${activeNodeId}"] .node-actions,
          [data-n-id="${activeNodeId}"] .node-actions,
          [id="${activeNodeId}"] .node-actions,
          g.node[data-n-id="${activeNodeId}"] .node-actions {
              opacity: 1 !important;
              pointer-events: auto !important;
          }
          
          .action-add, .action-edit {
              cursor: pointer !important;
          }
        `}
      </style>
    )}

    {selectedBranch !== 'All' && (
      <style>
        {`
          g.node {
             opacity: 0.2 !important;
             transition: opacity 0.3s ease;
             pointer-events: none !important;
          }
          
          .path {
             opacity: 0.15 !important;
             transition: opacity 0.3s ease;
          }

          ${nodes.filter(n => n.familyBranch === selectedBranch).map(n => `
            g.node[data-n-id="${n.id}"], 
            g.node[node-id="${n.id}"], 
            [node-id="${n.id}"]
          `).join(',\n')} {
             opacity: 1 !important;
             pointer-events: auto !important;
          }
        `}
      </style>
    )}

    {!isLoading && (
      <Box
        sx={{
          width: '100%',
          overflow: 'hidden',
          position: 'fixed',
          left: 0,
          top: isMobile ? '73px' : '63px',
          bottom: 0,
          right: 0,
          touchAction: 'none',
          '& .boc-light': {
            touchAction: 'none',
            userSelect: 'none',
            WebkitUserSelect: 'none'
          }
        }}
      >
        {nodes.length === 0 ? (
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1100,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '90%',
            maxWidth: '500px',
            minHeight: '300px',
            border: '2px dashed var(--glass-border)',
            borderRadius: '24px',
            background: 'rgba(255, 255, 255, 0.4)',
            backdropFilter: 'blur(8px)',
            transition: 'all 0.3s',
            '&:hover': {
              borderColor: 'var(--accent-color)',
              background: 'rgba(255, 255, 255, 0.6)',
            }
          }}>
            <Box sx={{
              width: '64px',
              height: '64px',
              borderRadius: '16px',
              background: 'var(--accent-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 3,
              boxShadow: '0 8px 16px rgba(74, 107, 44, 0.2)'
            }}>
              <PersonAddAlt1RoundedIcon sx={{ fontSize: 32, color: '#ffffff' }} />
            </Box>

            <Typography variant="h6" sx={{ color: 'var(--text-primary)', mb: 1, fontFamily: 'Inter', fontWeight: 600 }}>
              {language === 'vi' ? 'Chưa có thành viên nào' : 'No members yet'}
            </Typography>

            <Typography variant="body2" sx={{ color: 'var(--text-secondary)', mb: 4, fontFamily: 'Inter', maxWidth: '300px' }}>
              {language === 'vi' ? 'Nhấn vào nút bên dưới để thêm thành viên đầu tiên vào cây gia phả.' : 'Click the button below to add the first member to the tree.'}
            </Typography>

            {userData && userData.role === 'admin' && (
              <Button
                variant="outlined"
                sx={{
                  color: 'var(--accent-color)',
                  borderColor: 'var(--accent-color)',
                  borderWidth: '2px',
                  borderRadius: '12px',
                  padding: '8px 24px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  '&:hover': {
                    borderWidth: '2px',
                    borderColor: 'var(--accent-hover)',
                    backgroundColor: 'rgba(74, 107, 44, 0.05)'
                  }
                }}
                onClick={() => {
                  setMemberSelected(null);
                  setFormStatus('add');
                  setEditorContent('');
                  hanleOpenEditForm();
                }}
              >
                {language === 'vi' ? 'Thêm người đầu tiên' : 'Add first member'}
              </Button>
            )}
          </Box>
        ) : (
          <div
            ref={chartRef}
            style={{
              height: '100%',
              width: '100%',
              position: 'relative',
              overflow: 'hidden',
              touchAction: 'none',
            }}
          />
        )}
      </Box>
    )}
    <AutohideSnackbar type={type} open={openSnackbar} content={snackbarContent} handleClose={handleCloseSnackbar} />
  </Box>
};

export default FamilyTree;